import React from 'react';
import { styled } from '@mui/material/styles';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import Box from '@mui/material/Box';

import { ReactComponent as ClearIcon } from '../../../../../../../_base/layout/assets/layout-svg-icons/clear.svg';
import NumberFormatCustom from '../../../../../../components/formComponents/NumberFormatCustom';

const FilterField = styled(TextField)(() => ({
  width: 180,

  '@media (max-width:768px)': {
    width: 'auto',
    flex: 1,
    minWidth: 0,
  },

  '& .MuiOutlinedInput-root': {
    height: 44,
    background: '#ffff',
    borderRadius: 22,
    paddingRight: 6,
    fontSize: 17,
    fontWeight: 600,
    color: '#181c32',

    '& fieldset': {
      border: 'none',
    },

    '&:hover fieldset': {
      border: 'none',
    },

    '&.Mui-focused fieldset': {
      border: 'none',
    },
  },

  '& .MuiOutlinedInput-input': {
    padding: '0 18px',
  },

  '& input::placeholder': {
    color: '#7B7F8A',
    opacity: 1,
    fontWeight: 400,
  },
}));

const CircleButton = styled(IconButton)(() => ({
  padding: 0,
}));

export const PriceFields = ({
  priceFrom,
  priceTo,
  setPriceFrom,
  setPriceTo,
}: {
  priceFrom?: string;
  priceTo?: string;
  setPriceFrom: (value: string) => void;
  setPriceTo: (value: string) => void;
}) => {
  return (
    <Box
      display='flex'
      gap='12px'
      sx={{
        '@media (max-width:768px)': {
          width: '100%',
        },
      }}
    >
      <FilterField
        placeholder='Цена от'
        variant='outlined'
        value={priceFrom}
        onChange={e => setPriceFrom(e.target.value)}
        InputProps={{
          inputComponent: NumberFormatCustom as any,
          endAdornment: priceFrom ? (
            <InputAdornment position='end'>
              <CircleButton onClick={() => setPriceFrom('')}>
                <ClearIcon />
              </CircleButton>
            </InputAdornment>
          ) : null,
        }}
      />

      <FilterField
        variant='outlined'
        placeholder='Цена до'
        value={priceTo}
        onChange={e => setPriceTo(e.target.value)}
        InputProps={{
          inputComponent: NumberFormatCustom as any,
          endAdornment: priceTo ? (
            <InputAdornment position='end'>
              <CircleButton onClick={() => setPriceTo('')}>
                <ClearIcon />
              </CircleButton>
            </InputAdornment>
          ) : null,
        }}
      />
    </Box>
  );
};
